import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import ErrorMsg from "../form/errorMsg";
import "./modal.css";
import { useDispatch } from "react-redux";
import {
  companyListAction,
  stockReconciliationExportAction,
} from "../../redux/actions/orderActions";
import exportFromJSON from "export-from-json";
import moment from "moment";

const StockReconciliationExportModal = ({ StockShow, stockClose }) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const fileName = "download";
  const exportType = exportFromJSON.types.csv;

  useEffect(() => {
    dispatch(companyListAction(onFetchSuccess, onFetchError));
  }, []);

  const onFetchSuccess = (data) => {
    setOptions(data);
  };
  const onFetchError = (err) => {
    console.log(err);
  };

  const initialValues = {
    vendor_id: [],
    from_date: "",
    to_date: "",
  };
  const validationSchema = Yup.object().shape({
    vendor_id: Yup.string().required("Required"),
    from_date: Yup.date().required("Required"),
    to_date: Yup.date().required("Required"),
  });
  const onSubmit = (values) => {
    console.log(values, "selectedselectedselectedselected");
    dispatch(stockReconciliationExportAction(values, onSuccess, OnError));
  };

  const onSuccess = (data) => {
    console.log(data.data.data, "jsonArray");
    const jsonArray = data.data.data?.map((item) => ({
      "PO Number": item?.po_number || "--",
      "PO Date": item?.po_date || "--",
      "Company Product ID": item?.company_product_id || "--",
      "Jivini Product ID": item?.product_id || "--",
      "Product Name": item?.product_name || "--",
      "Division Name": item?.division_name || "--",
      MRP: item?.mrp || "--",
      PTR: item?.ptr || "--",
      PTS: item?.pts || "--",
      "Doctor Code": item?.doctor_code || "--",
      "Doctor Name": item?.doctor_name || "--",
      "Pharmacy Code": item?.pharmacy_code || "--",
      "Pharmacy Name": item?.pharmacy_name || "--",
      "City Name": item?.city || "--",
      "Order ID": item?.order_id || "--",
      "Order Date": item?.order_date || "--",
      "Ordered Qty": item?.order_quantity || "--",
      "Ordered Free Qty": item?.order_free_quantity || "--",
      "Gross Value Of Order Qty@Ptr": item?.product_gross_value || "--",
      "Gross Value Of Order Free Qty@Ptr":
        item?.gross_value_of_ordered_free_qty_ptr || "--",
      "Gross Value Of Order Qty@Pts": item?.product_gross_value_pts || "--",
      "Gross Value Of Order Free Qty@Pts":
        item?.gross_value_of_ordered_free_qty_pts || "--",
      "Distributors Jivini Id": item?.distributor_code || "--",
      "Distributors Name": item?.distributor_name || "--",
      "Distributors Location": item?.distributor_location || "--",
      "Distributors Invoice Id": item?.distributor_invoice_id || "--",
      "Distributors Invoice Date": item?.distributor_invoice_date
        ? moment(item?.distributor_invoice_date).format("DD-MM-YYYY")
        : "--",
      "Distributors Invoiced Qty": item?.invoice_qty || "--",
      "Distributors Invoiced Free Qty": item?.invoice_free_qty || "--",
      "Supplied Ptr": item?.invoice_free_qty || "--",
      "Gross Value Of Distributor Inv Qty@Ptr":
        item?.gross_value_of_dist_inv_qty_ptr || "--",
      "Gross Value Of Distributor Inv Free Qty@Ptr":
        item?.gross_value_of_dist_inv_free_qty_ptr || "--",
      "Gross Value Of Distributor Inv Qty@Pts":
        item?.gross_value_of_dist_inv_qty_pts || "--",
      "Gross Value Of Distributor Inv Free Qty@Pts":
        item?.gross_value_of_dist_inv_free_qty_pts || "--",
      "Gross Value Of Distributor Inv Qty@Supplied Ptr":
        item?.gross_value_of_dist_inv_qty_supplied_ptr || "--",
      "Gross Value Of Distributor Inv Free Qty@Supplied Ptr":
        item?.gross_value_of_dist_inv_free_qty_supplied_ptr || "--",
      "CFA Jivini Id": item?.distributor_cfa_code || "--",
      "CFA Name": item?.distributor_cfa_name || "--",
      "CFA Location": item?.distributor_cfa_location || "--",
      "CFA Inv No Reimbursement": item?.cfa_invoice_id || "--",
      "CFA Inv Date Reimbursement": item?.cfa_invoice_date
        ? moment(item?.cfa_invoice_date).format("DD-MM-YYYY")
        : "--",
      "Approval Linked Level 1 Name": item?.linked_level1_name || "--",
      "Approval Linked Level 1 Code": item?.linked_level1_code || "--",
      "Approval Linked Level 1 Mobile": item?.linked_level1_mobile || "--",
      "Approval Linked Level 2 Name": item?.linked_level2_name || "--",
      "Approval Linked Level 2 Code": item?.linked_level2_code || "--",
      "Approval Linked Level 2 Mobile": item?.linked_level2_mobile || "--",
    }));
    exportFromJSON({ data: jsonArray, fileName, exportType });
    stockClose();
  };
  const OnError = () => {};

  return (
    <div className="px-5 mx-5">
      <Modal
        centered
        show={StockShow}
        dialogClassName="stock-export-container col-8 px-3 mx-auto"
        contentClassName="stock-export-container "
      >
        <ModalBody>
          <div className="mx-3 mt-2 fw_600 fn_Nunito fs_20">
            Stock reconciliation Export
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values }) => (
              <Form>
                <div className="px-3 pb-2 pt-2">
                  <div className="mt-2">
                    <label className="fn_Nunito color_262c3d">Company</label>
                    <div className="mt-1">
                      <Field>
                        {({ form, Field }) => (
                          <Select
                            options={options}
                            styles={customStyles}
                            placeholder={"Select Company"}
                            {...Field}
                            value={options.find(
                              (s) => s.value == values.vendor_id
                            )}
                            onChange={(selected) => {
                              setFieldValue("vendor_id", selected.value);
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="vendor_id" />
                    </div>
                  </div>
                  <div className=" d-flex my-3 gap-3">
                    <div className="mx-1">
                      <label className="fn_Nunito color_262c3d ">From</label>
                      <div className=" d-flex mt-1 ">
                        <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                          <Field name={"from_date"}>
                            {({ field, form }) => (
                              <input
                                type="date"
                                {...field}
                                placeholder="Select Date"
                                className="amount_input py-1 ms-1"
                                name="from_date"
                              />
                            )}
                          </Field>
                          {/* <img src={date} /> */}
                        </div>
                      </div>
                      <ErrorMsg name="from_date" />
                    </div>
                    <div className="me-3">
                      <label className="fn_Nunito color_262c3d ">To</label>
                      <div className=" d-flex mt-1">
                        <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                          <Field name={"to_date"}>
                            {({ field, form }) => (
                              <input
                                type="date"
                                {...field}
                                placeholder="Select Date"
                                className="  amount_input  py-1  ms-1"
                                name="to_date"
                              />
                            )}
                          </Field>
                        </div>
                      </div>
                      <ErrorMsg name="to_date" />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end pt-4 pb-2 me-2 gap-2">
                    <button
                      className="modal-close-btn px-3 py-1 fs_12"
                      type="button"
                      onClick={() => stockClose()}
                    >
                      close
                    </button>
                    <div>
                      <button
                        className="modal-submit-btn text-white px-3 py-2 fs_12"
                        type="submit"
                      >
                        <span className="fw_600">Export</span>
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default StockReconciliationExportModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,

    border: " 1px solid #B0B3C7",
  }),
  control: (base, state) => ({
    ...base,
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    border: "1px solid #747F9E",
    borderRadius: "7px",
    width: "100%",

    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
